import { Grid } from "@mui/material";
import {
  GridContainerStyle,
  PageContainer,
} from "../../components/Common/Container/ContainerStyled";
import { useDeviceType } from "../../hooks/useDeviceType";
import GuidePdfViewer from "../../components/Common/Guide/GuidePdfViewer";

const MeetingRoomGuidePage = () => {
  const deviceType = useDeviceType();

  return (
    <PageContainer>
      <Grid sx={{ ...GridContainerStyle(deviceType), width: "100%" }}>
        <GuidePdfViewer filePath="/guide/meetingroomGuide.pdf" />
      </Grid>
    </PageContainer>
  );
};

export default MeetingRoomGuidePage;
